module.exports = __webpack_public_path__ + "0-es2015.10470041d8e09aff5fd8.worker.js"